import React from "react";
import { FeatherCreditCard, FeatherFileText } from "@subframe/core";
import { Button } from "../../../../ui/components/Button";
import { UploadDocumentCard } from "./UploadDocumentCard";

interface UploadDocumentsSectionProps {
  filters?: React.ReactNode;
  canCreateInvoice: boolean;
  canCreateBill: boolean;
  canUploadInvoices: boolean;
  canUploadBills: boolean;
  canUploadBankStatements: boolean;
  uploadingInvoices: boolean;
  uploadingBills: boolean;
  onCreateManualInvoice: () => void;
  onCreateManualBill: () => void;
  onUploadInvoice: () => void;
  onUploadBill: () => void;
  onBulkUpload: () => void;
  onUploadBankStatement: () => void;
  onUploadCreditCardBill: () => void;
}

export const UploadDocumentsSection: React.FC<UploadDocumentsSectionProps> = ({
  filters,
  canCreateInvoice,
  canCreateBill,
  canUploadInvoices,
  canUploadBills,
  canUploadBankStatements,
  uploadingInvoices,
  uploadingBills,
  onCreateManualInvoice,
  onCreateManualBill,
  onUploadInvoice,
  onUploadBill,
  onBulkUpload,
  onUploadBankStatement,
  onUploadCreditCardBill,
}) => {
  return (
    <div className="flex w-full flex-col items-start gap-4">
      <div className="flex w-full items-center justify-between">
        <span className="text-heading-2 font-heading-2 text-default-font">
          Upload Documents
        </span>
        <div className="flex items-center gap-2">
          {canCreateInvoice && (
            <Button
              variant="neutral-primary"
              icon={<FeatherFileText />}
              onClick={onCreateManualInvoice}
            >
              Create Manual Invoice
            </Button>
          )}
          {canCreateBill && (
            <Button
              variant="neutral-primary"
              icon={<FeatherFileText />}
              onClick={onCreateManualBill}
            >
              Create Manual Bill
            </Button>
          )}
        </div>
      </div>

      {filters}

      <div className="flex w-full gap-4 items-stretch">
        <UploadDocumentCard
          title="Invoices"
          icon={<FeatherFileText />}
          iconVariant="neutral"
          isUploading={uploadingInvoices}
          disabled={!canUploadInvoices}
          onUpload={onUploadInvoice}
          onBulkUpload={onBulkUpload}
          bulkUploadDisabled={!canUploadInvoices}
        />
        <UploadDocumentCard
          title="Bills"
          icon={<FeatherFileText />}
          iconVariant="warning"
          isUploading={uploadingBills}
          disabled={!canUploadBills}
          onUpload={onUploadBill}
          onBulkUpload={onBulkUpload}
          bulkUploadDisabled={!canUploadBills}
        />
        <UploadDocumentCard
          title="Bank Statements"
          icon={<FeatherFileText />}
          iconVariant="success"
          disabled={!canUploadBankStatements}
          onUpload={onUploadBankStatement}
        />
        <UploadDocumentCard
          title="Credit Card Bills"
          icon={<FeatherCreditCard />}
          iconVariant="error"
          disabled={!canUploadBankStatements}
          onUpload={onUploadCreditCardBill}
        />
      </div>
    </div>
  );
};
